export const BASE_URL = 'https://api.almashriq.edunixsystem.com'

export const IMAGE_URL = 'https://api.almashriq.edunixsystem.com/files/logo.png'
